import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import { ProjectTypes } from '../types';
import { checkHasContextPath, getContextPath } from '../utils';
import { languages, LanguageTypes } from '../commons/constants';
import { storeName } from '../redux/models/layout.model';
import { getProject } from '../redux/selectors/project.selector';

const useLanguage = (): void => {
  const history = useHistory();
  const location = useLocation();

  const project: ProjectTypes = useSelector(getProject);
  const locale: LanguageTypes = useSelector((state) => state[storeName].locale);
  const dispatch = useDispatch()[storeName];

  useEffect(() => {
    const hasContextPath = checkHasContextPath();
    // set default language to VI when not have context path
    if (!hasContextPath) {
      dispatch.setLocale(languages['VI']);
      return;
    }

    // set language base on context path
    const contextPath = getContextPath();
    const language = Object.values(languages).find((i) => i.contextPath === contextPath);
    if (!language) return;
    dispatch.setLocale(language);
  }, []);

  useEffect(() => {
    // check has context path
    // and base on project config language for redirect if current language not allow
    const hasContextPath = checkHasContextPath();
    if (!hasContextPath || !project) return;

    const languageKey = project.language;
    if (locale.apiLanguage === languageKey) return;

    const language = Object.values(languages).find((i) => i.apiLanguage === languageKey);
    if (!language) return;

    history.push({
      pathname: location.pathname.replace(locale.contextPath, language.contextPath),
      hash: location.hash,
      search: location.search,
    });
  }, [project]);

  useEffect(() => {
    const hasContextPath = checkHasContextPath();
    if (!hasContextPath || !project) return;

    const contextPath = getContextPath();
    const language = Object.values(languages).find((i) => i.contextPath === contextPath);
    // check current context path is not match with store language
    if (locale.locale !== language.locale) {
      window.location.reload();
    }
  }, [location]);
};

export default useLanguage;
